//tslint:disable-next-line
const { appName } = require('../../package.json');
/* tslint:disable:no-use-before-declare */
import { WithAuthAttributes } from '@fuselab/ui-fabric/withAuth';
import { initializeIcons } from '@uifabric/icons';
import { Fabric } from 'office-ui-fabric-react/lib-commonjs/Fabric';
import * as React from 'react';
import { TopHeader } from '../topHeader';
import classNames from './app.classNames';
/* tslint:enable:no-use-before-declare */
declare global {
  interface Window {
    cdnRoot: string;
    WcpConsent: any;
    siteConsent: any;
  }
}

if (window.cdnRoot) {
  initializeIcons(`${window.cdnRoot}/assets/fonts/`);
} else {
  // Register icons and pull the fonts from the default SharePoint cdn:
  initializeIcons();
}

if (window.WcpConsent) {
  window.WcpConsent.init('en-US', 'cookie-banner', function (err, _siteConsent) {
    if (!err) {
      window.siteConsent = _siteConsent;
    }
  });
}

const imagesRoot = `${window.cdnRoot}/assets/${appName}/images`;

export type AppAttributes = WithAuthAttributes;

//tslint:disable:max-func-body-length
export const App = () => {
  return (
    <Fabric className={classNames().root}>
      <div className={classNames().full} role='main'>
        <TopHeader />
        <section className={classNames().footerSection}>
          <div className='ms-Grid' dir='ltr'>
            <div className={classNames().copyrightSection}>
              <span>© 2019 Microsoft</span>
            </div>
          </div>
        </section>
      </div>
    </Fabric>
  );
};
